module.exports = __webpack_public_path__ + "static/media/damaha_hraswo_duu.33381c74.ogg";